import { motion } from "framer-motion";
import { Wallet, Coins, Repeat, Flag, Copy } from "lucide-react";
import { copyCa } from "./Navbar";
import { CA } from "../lib/constants";

const reveal = {
  initial: { y: 36, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, amount: 0.15 },
};

const STEPS = [
  {
    icon: Wallet,
    title: "Get a Wallet",
    body: "Download Phantom or Solflare — your home under the sea.",
  },
  {
    icon: Coins,
    title: "Load Up SOL",
    body: "Fund your wallet with SOL from any exchange or on-ramp.",
  },
  {
    icon: Repeat,
    title: "Swap for $BLUE",
    body: "Open DexScreener or Raydium, paste the CA and swap SOL for $BLUE.",
  },
  {
    icon: Flag,
    title: "Welcome to the Pod",
    body: "Join Telegram, make some noise and ride the waves with us.",
  },
];

export default function HowToBuy() {
  return (
    <section
      id="how-to-buy"
      data-testid="how-to-buy-section"
      className="relative bg-ocean-navy py-24 text-white sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div {...reveal} className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-extrabold uppercase tracking-[0.3em] text-ocean-sky">
            How to Buy
          </p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight sm:text-5xl">
            Dive in. Four easy strokes.
          </h2>
        </motion.div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`how-to-buy-step-${i + 1}`}
              {...reveal}
              transition={{ ...reveal, delay: i * 0.1 }}
              className="group relative rounded-3xl border-[3px] border-ocean-sky/60 bg-white/5 p-7 backdrop-blur transition-all duration-300 hover:-translate-y-2 hover:border-ocean-yellow hover:bg-white/10"
            >
              <span className="font-display text-5xl font-semibold text-ocean-yellow">
                0{i + 1}
              </span>
              <div className="mt-5 inline-flex rounded-2xl border-[3px] border-ocean-navy bg-ocean-sky p-3 text-ocean-navy shadow-[3px_3px_0_#0F172A]">
                <s.icon className="h-5 w-5" />
              </div>
              <h3 className="mt-4 font-display text-xl font-semibold">
                {s.title}
              </h3>
              <p className="mt-2 text-sm font-medium leading-relaxed text-white/70">
                {s.body}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          {...reveal}
          transition={{ ...reveal, delay: 0.2 }}
          className="sticker mx-auto mt-14 flex max-w-4xl flex-col items-center justify-between gap-4 rounded-3xl bg-white p-6 text-ocean-navy sm:flex-row"
        >
          <p className="px-2 text-center font-mono text-sm font-bold sm:text-left sm:text-lg">
            {CA}
          </p>
          <button
            data-testid="how-to-buy-copy"
            onClick={copyCa}
            className="btn-push sticker-sm flex shrink-0 items-center gap-2 rounded-2xl bg-ocean-yellow px-6 py-3 font-display text-base font-semibold"
          >
            <Copy className="h-5 w-5" />
            Copy CA
          </button>
        </motion.div>
      </div>
    </section>
  );
}
